"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineText = exports.ImageTextWrapper = void 0;
const react_1 = __importDefault(require("react"));
const lbp2_osd_instance_1 = require("@jeffreycwitt/lbp2.osd-instance");
const prop_types_1 = __importDefault(require("prop-types"));
require("./image-text-wrapper.scss");
const ImageTextWrapper = (props) => {
    return (
    // <div className={props.targetLabel === props.label ? "image-text-wrapper target" : "image-text-wrapper"}>
    react_1.default.createElement("div", { style: { width: props.viewerWidth + "px" } },
        react_1.default.createElement(lbp2_osd_instance_1.OSDInstance, { imageurl: props.imageurl, coords: props.coords, viewerWidth: props.viewerWidth }),
        (props.text || props.number || props.label) && react_1.default.createElement(LineText, { text: props.text, number: props.number, label: props.label, lineTextViewStyle: props.lineTextViewStyle })));
};
exports.ImageTextWrapper = ImageTextWrapper;
ImageTextWrapper.defaultProps = {
    imageurl: "",
    text: "",
    coords: "",
    viewerWidth: 1000,
    lineTextViewStyle: "thin", // wide
};
ImageTextWrapper.propTypes = {
    /**
    * @description imageurl (without iiif parameters) for which logo will be requested
    **/
    imageurl: prop_types_1.default.string.isRequired,
    /**
    * @description a comma separated string indicated coordinates in the following pattern x,y,w,h (follows the IIIF coord pattern)
    **/
    coords: prop_types_1.default.string,
    /**
     * @description default setting for viewer width; default is 1000
     * @default 1000
     */
    lineTextViewStyle: prop_types_1.default.string,
    /**
     * @description a prop to control styling of line text display; "thin" (default) which has no padding and is left aligned or "wide" which has padding and is justified
     */
};
// this could be broken into its own component someday if necessary, but doesn't seem helpful right now
const LineText = (props) => {
    return (react_1.default.createElement("div", { className: props.lineTextViewStyle === "wide" ? "itw-text-wide" : "itw-text-thin" },
        props.number && react_1.default.createElement("span", null,
            props.label.split("(")[0],
            "/"),
        props.number && react_1.default.createElement("span", null, props.number),
        react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: props.text } })));
};
exports.LineText = LineText;
//# sourceMappingURL=image-text-wrapper.js.map